module.exports = __webpack_public_path__ + "img/img11.3552a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img11.png
// module id = 187
// module chunks = 0